<script>
import forminput from "../formcomponet/forminput.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import omalzeme from "@/models/omalzeme";

import moment from "moment";
export default {
  mixins: [apibtoast, apigeneric, omalzeme],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    formtextarea,
  },
  watch: {
    Id() {
      if (this.AddEdit != "TalepAdd") this.FormData = this.Id;
    },
  },
  created() {
    if (this.AddEdit == "TalepAdd") {
      this.FormData === this.omalzemeData;
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add" || this.AddEdit == "TalepAdd") {
          this.FormData.Kayittarihi =
            moment(new Date()).format("YYYY-MM-DDTHH:mm:ss") + "Z";
          this.Post("omalzeme", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
            }
          });
          this.$bvModal.hide("omalzeme");
        } else {
          this.Update("omalzeme", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$emit("TableUpdate");
              this.$bvModal.hide("omalzeme");
            }
          });
        }
      }
    },
    Get() {},
    FileUpload() {
      var file = this.$refs.file.files[0];
      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg") {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Sat",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {

            this.FormData.Image = res.Data.filename;

            this.$toast.success(this.$t("ToasMessage.MalzemeFilePozitif"));
          } else {
            this.$toast.error(this.$t("ToasMessage.MalzemeFileNegatif"));
          }
        });
      }
      else {
        this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }


    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="omalzeme"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('omalzeme.AddEdit.FormTitleEdit')
          : $t('omalzeme.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <forminput
          :FormDataType="FormDataType.Adi"
          :Value="FormData.Adi"
          :v="$v.FormData.Adi"
          @input="FormData.Adi = $event"
        />
        <formcombobox
          :FormDataType="FormDataType.Grupid"
          :Value="FormData.Grupid"
          :v="$v.FormData.Grupid"
          @input="FormData.Grupid = $event"
        />
        <formcombobox
          :FormDataType="FormDataType.Olcubirimi"
          :Value="FormData.Olcubirimi"
          :v="$v.FormData.Olcubirimi"
          @input="FormData.Olcubirimi = $event"
        />
        <forminput
          :FormDataType="FormDataType.Barkod"
          :Value="FormData.Barkod"
          :v="$v.FormData.Barkod"
          @input="FormData.Barkod = $event"
        />
        <forminput
          :FormDataType="FormDataType.Karekod"
          :Value="FormData.Karekod"
          :v="$v.FormData.Karekod"
          @input="FormData.Karekod = $event"
        />

        <formtextarea
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        />
                            <div class="col-md-12">
                              <b-form-group class="mb-3" style="font-weight: 500" :label="FormDataType.Image.FieldTitle"><a v-if="FormData.Image" :href="
                                this.$config.FILES_URL +
                                'sat/' +
                                FormData.Image
                              " target="_blanl">
                                  Mevcut Dosya
                                </a>
                                <input class="form-control" ref="file" type="file" v-on:change="FileUpload($event)"
                                  id="FormData.Image" accept=".jpg, .jpeg, .png" />
                              </b-form-group>
                            </div>

        <button class="btn btn-primary" type="submit">
          {{ $t("omalzeme.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
